export const authColors = {
  primary: '#43A047',
  primaryDark: '#3C9041',
  heading: '#111827',
  body: '#303643',
  label: '#4B5563',
  placeholder: '#6B7280',
  disabledText: '#BFC3CB',
  border: '#E5E7EB',
  /** Neutral/2 — card outline on auth forms */
  surface: '#F7F7F8',
  white: '#FFFFFF',
  error: '#E2483C',
  successBannerBg: '#F0F9F1',
  stepConnector: '#8CCF8F',
  /** Neutral/8 — interactive icons (eye, etc.) */
  icon: '#2B2B2B',
};

export const authTypography = {
  heading04: 'font-size:30px;line-height:40px;font-weight:700;',
  heading05: 'font-size:24px;line-height:32px;font-weight:700;',
  /** Left-panel supporting copy under the heading (Figma 18/24 Regular). */
  lead: 'font-size:18px;line-height:24px;font-weight:400;',
  subtitle06: 'font-size:16px;line-height:24px;font-weight:600;',
  body02: 'font-size:16px;line-height:24px;font-weight:400;',
  body02Med: 'font-size:16px;line-height:24px;font-weight:500;',
  body03: 'font-size:14px;line-height:22px;font-weight:400;',
  body03Med: 'font-size:14px;line-height:22px;font-weight:500;',
  body03Semi: 'font-size:14px;line-height:22px;font-weight:600;',
  body04: 'font-size:12px;line-height:18px;font-weight:500;',
};

/** Figma effect style "DropdownForm": 0 / 20 blur 64, #3A550914 */
export const authShadow = {
  card: '0 20px 64px rgba(58, 85, 9, 0.08)',
  dropdown: '0 20px 64px rgba(58, 85, 9, 0.08)',
};

export const AUTH_DESKTOP_MIN_WIDTH = 1024;
/**
 * At or above this width desktop uses the mid/large typography / logo / stepper scale.
 * Below it (but still desktop), UI scales down — covers Figma 1280 and 1024 frames.
 */
export const AUTH_DESKTOP_LARGE_MIN = 1440;
/** Extra-large desktop — typography / logo / stepper scale-up. */
export const AUTH_DESKTOP_XL_MIN = 1728;
/** Tablet and up: 2-col field rows and wider page padding (Figma iPad). */
export const AUTH_TABLET_MIN_WIDTH = 768;
/**
 * Safe-zone content widths (centered):
 * - XL (≥1728): 1600
 * - LG (1440–1727): 1312
 * - MD (1200–1439): 1200
 * - SM (1024–1199): 944
 */
export const AUTH_SAFE_ZONE_MD_MIN = 1200;
export const AUTH_SAFE_ZONE_XL = 1600;
export const AUTH_SAFE_ZONE_LG = 1312;
export const AUTH_SAFE_ZONE_MD = 1200;
export const AUTH_SAFE_ZONE_SM = 944;
/** Min horizontal padding from viewport edge on MD/LG/XL safe-zone bands. */
export const AUTH_SAFE_ZONE_PAD = 64;
